import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'shared/constants';

export const useGoBack = (fallback = ROUTES.HOME) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    // The history index also catches a first entry whose key was rotated by a replace
    const isFirstEntry = location.key === 'default' || (window.history.state?.idx ?? 0) === 0;
    if (isFirstEntry) {
      navigate(fallback);
      return;
    }
    navigate(-1);
  }, [navigate, location.key, fallback]);
};
